<template>

<div class="overflow-hidden" v-show="$_.size(images)">

        <!-- :options="{zIndex: 9999999999, backdrop: 'static'}" -->
                <!-- :images="images" -->
    <ViewerVue3
        :options="{zIndex: 9999999999, backdrop: 'static'}"
                :images="items"
                @inited="inited"
                class="viewer unvisible"
                ref="viewerRef">

        <template #default="scope">
            <img v-for="(src, key) in scope.images" :key="key" :src="dir + src" :alt="src" />
        </template>
    </ViewerVue3>
</div>

<div class="col-12 text-center q-my-sm">
    <q-btn label="Diaporama" @click="showViewer" no-caps square outline dense size="md" icon-right="photo_size_select_large" color="grey" /><!--  icon-right="photo_library" -->
</div>

</template>

<script setup>

import 'viewerjs/dist/viewer.css'
import { component as ViewerVue3 } from "v-viewer"

import { ref } from '@vue/reactivity'

const props = defineProps({
    items: {Array, default: []},
    dir: {String, default: 'page'},
})
// log(props.dir)

const viewerRef = ref(null)

const inited = (viewer) =>{
    _.delay(()=>{
        viewerRef.value = viewer
    }, 1000)

}
const showViewer = () =>{
    viewerRef.value?.show()
}

</script>
